import { API_ROOT } from '../../config/config'
import { doGet, doPost } from './utils'

export const getSchema = (projectVersionId) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/review/paymentcheck`
  return doGet(url)
}

export const savePaymentCheck = (request) => {
  const url = `${API_ROOT}`
  return doPost(url, request)
}

export const getPaymentCheckSchema = (projectVersionId) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/review/paymentcheck`
  return doGet(url)
}
